import React from 'react';
import SVG from 'react-inlinesvg';

import './index.css';
import FormIdea from '../../components/formIdea';
import phone from '../../images/contacts/phone.svg';
import email from '../../images/contacts/email.svg';
import skype from '../../images/contacts/skype.svg';

class Contacts extends React.Component {
  render() {
    return (
      <div className="contacts page">
        <div className="contacts__header">
          <h1>{localStorage.getItem('lang') == 'ru'? 'Контакты':'Contacts'}</h1>
          <span className="subtitle">{localStorage.getItem('lang') == 'ru'? 'Напишите нам':'Write us'}</span>
        </div>
        <div className="contacts__items">
          <div className="contacts__item">
            <SVG src={phone} className="contacts__item__icon" />
            <h3 className="contacts__item__title">{localStorage.getItem('lang') == 'ru'? 'Телефон':'Phone'}</h3>
            <p className="contacts__item__description">{localStorage.getItem('lang') == 'ru'? 'Вы можете заказать звонок или позвонить нам с ПН - ПТ с 09:00 до 18:00':
            'You can order a call or call us from 09:00 to 18:00 Monday-Friday '}</p>
            {localStorage.getItem('lang') == 'ru'? <a href="tel:+7 903 406 64 99" className="contacts__item__value">+7 (903) 406-64-99</a>:<a href="tel: +1 818 851 15 02" className="contacts__item__value">+1 (818) 851-15-02</a>}
          </div>
          <div className="contacts__item">
            <SVG src={email} className="contacts__item__icon" />
            <h3 className="contacts__item__title">email</h3>
            <p className="contacts__item__description">{localStorage.getItem('lang') == 'ru'? 'Если у Вас есть идея мы готовы обсудить детали':
            'If you have an idea we are ready to discuss the details'}</p>
            <a href="mailto:pm@leotrado.com" className="contacts__item__value">pm@leotrado.com</a>
          </div>
        </div>
        <FormIdea />
      </div>
    )
  }
}

export default Contacts;



// WEBPACK FOOTER //
// ./src/pages/contacts/index.jsx